export type WhitelistBank = {
  search: string;
  filter?: (bank: any) => boolean;
  iconUrl: string;
  name: string;
  bic?: string;
  slug?: string | number;
};

export default [
  {
    search: "BDWBDEMM003",
    bic: "BDWBDEMM003",
    iconUrl: "https://rentablo.de/assets/bankLogos/BDWBDEMM003_square.png",
    name: "Smartbroker",
    slug: "SmartbrokerPlus",
  },
  {
    search: "HELADEF1822",
    bic: "HELADEF1822",
    iconUrl: "https://rentablo.de/assets/bankLogos/SPARKASSE_square.png",
    name: "1822direkt",
    slug: 275209,
  },
  {
    search: "comdirect",
    bic: "COBADEHDXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/COMDIRECT_square.png",
    name: "Comdirect",
    slug: 24463,
  },
  {
    search: "Commerzbank",
    bic: "COBADEFFXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/COMMERZBANK_square.png",
    name: "Commerzbank",
    slug: 273621,
  },
  {
    search: "CSDBDE71XXX",
    bic: "CSDBDE71XXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/CSDBDE71XXX_square.png",
    name: "Consorsbank",
    slug: 26980,
  },
  {
    search: "BYLADEM1001",
    bic: "BYLADEM1001",
    iconUrl: "https://rentablo.de/assets/bankLogos/BYLADEM1001_square.png",
    name: "DKB",
    slug: 24353,
  },
  {
    search: "FlatexDEGIRO",
    bic: "FlatexDEGIRO",
    filter: (bank) => bank.name === "flatex",
    iconUrl: "https://rentablo.de/assets/bankLogos/FLATEX_square.png",
    name: "flatex",
    slug: 273604,
  },
  {
    search: "BIIWATWWXXX",
    bic: "BIIWATWWXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/FLATEX_square.png",
    name: "flatex AT",
    slug: 279729,
  },
  {
    search: "INGDDEFFXXX",
    bic: "INGDDEFFXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/INGDDEFFXXX_square.png",
    name: "ING",
    slug: 25546,
  },
  {
    search: "quirion (Robo)",
    bic: "QUBKDEBBXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/QUBKDEBBXXX_square.png",
    name: "Quirion (Robo)",
    slug: "Quirion",
  },
  {
    search: "S Broker Wiesbaden",
    bic: "PULSDEDDXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/SBROKER_square.png",
    name: "S Broker Wiesbaden",
    slug: 274426,
  },
  {
    search: "SCABDEMMXXX",
    bic: "SCABDEMMXXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/SCABDEMMXXX_square.png",
    name: "Scalable Capital",
    slug: "ScalableCapital",
  },
  {
    search: "TREBDED1XXX",
    bic: "TREBDED1XXX",
    iconUrl: "https://rentablo.de/assets/bankLogos/TREBDED1XXX_square.png",
    name: "Trade Republic",
    slug: "TradeRepublic",
  },
] as WhitelistBank[];
